import { featuredProjectIds, projects, portfolioPdfUrl } from './projects';
import resumeUrl from '../../assets/pdfs/Resume.pdf';
import PdfDownload from '../buttons/PdfDownload';

export const ExternalLink = ({ href, children, className }) => (
  <a href={href} className={className} target="_blank" rel="noopener noreferrer">{children}</a>
);

const ProfileOverview = ({ onSelectProject }) => (
  <div className="profile-overview">
    <div className="profile-heading">
      <span className="file-label">SOBRE_MIM.txt</span>
      <h1>João Pedro<br />Santana Silva Santos</h1>
      <p className="profile-role">Pesquisador em robótica · Desenvolvedor · Fundador e CTO da AquaFeed</p>
      <p>Conecto pessoas, sensores e robôs por meio de software. Sou pesquisador do Laboratório de Inovação e Criatividade (LABIC), no IFS Campus Lagarto, e graduando em Sistemas de Informação. Trabalho com visão computacional, IoT, inteligência artificial e desenvolvimento de aplicações.</p>
      <div className="profile-links">
        <ExternalLink href="https://github.com/J3ipy">GitHub</ExternalLink>
        <ExternalLink href="https://www.linkedin.com/in/joaopedro2005/">LinkedIn</ExternalLink>
        <ExternalLink href="https://orcid.org/0009-0000-3276-0344">ORCID</ExternalLink>
        <ExternalLink href="http://lattes.cnpq.br/0393390160975070">Lattes</ExternalLink>
        <a href="mailto:pedrosant1905@gmail.com">E-mail</a>
      </div>
      <div className="profile-downloads">
        <PdfDownload href={portfolioPdfUrl} filename="Joao_Pedro_Santos_Portfolio.pdf">↓ Portfólio em PDF · English</PdfDownload>
        <PdfDownload href={resumeUrl} filename="Joao_Pedro_Santos_Europass.pdf">↓ Currículo Europass · English</PdfDownload>
      </div>
    </div>
    <section className="profile-section" aria-labelledby="featured-heading">
      <h2 id="featured-heading">Trabalhos selecionados</h2>
      <p className="section-intro">Cinco projetos que representam minhas principais competências. Selecione um para conhecer o contexto e minha contribuição.</p>
      <div className="featured-projects">
        {featuredProjectIds.map((id, index) => (
          <button key={id} className="featured-project" onClick={() => onSelectProject(id)}>
            <span className="project-number">0{index + 1}</span>
            <span><span className="featured-title">{projects[id].title}</span><span className="featured-meta">{projects[id].technologies.slice(0, 3).join(' · ')}</span></span>
            <span aria-hidden="true">→</span>
          </button>
        ))}
      </div>
    </section>
    <section className="profile-section" aria-labelledby="skills-heading">
      <h2 id="skills-heading">Competências</h2>
      <dl className="skills-grid">
        <div><dt>Robótica e pesquisa</dt><dd>Python, C++, MATLAB, visão computacional, planejamento de caminhos e interação humano-robô.</dd></div>
        <div><dt>Desenvolvimento</dt><dd>Java, JavaScript, React, Next.js, Spring, Django e integração de APIs.</dd></div>
        <div><dt>Dados e IoT</dt><dd>Arduino, ESP32, MQTT, SQL, MongoDB, PostgreSQL e InfluxDB.</dd></div>
        <div><dt>Trabalho em equipe</dt><dd>Gestão de projetos, liderança técnica, Scrum, Kanban, Git e comunicação científica.</dd></div>
      </dl>
    </section>
    <section className="profile-section" aria-labelledby="experience-heading">
      <h2 id="experience-heading">Trajetória</h2>
      <ul className="profile-timeline">
        <li><b>2024–atual · AquaFeed</b><p>Fundador e CTO. Desenvolvimento tecnológico e planejamento da startup, participante de StartupNE 2025 e Catalisa ICT 2025.</p></li>
        <li><b>2023–atual · LABIC / IFS</b><p>Pesquisa em robótica, redes neurais, IoT e interação humano-robô. Monitoria voluntária em programação e estruturas de dados.</p></li>
        <li><b>2022–2023 · Margi Education</b><p>Ensino de computação para crianças, com Lua e programação em blocos no Minecraft Education.</p></li>
      </ul>
      <p><b>Formação:</b> Sistemas de Informação no IFS (em andamento desde 2023) e Técnico em Desenvolvimento de Sistemas pelo SENAI (2022).</p>
      <p><b>Idiomas:</b> português nativo, inglês C1 e francês A2.</p>
    </section>
    <section className="profile-section" aria-labelledby="research-heading">
      <h2 id="research-heading">Publicações selecionadas</h2>
      <ul className="publication-list">
        <li><ExternalLink href="https://doi.org/10.5753/semish.2025.8257">Sistema de Detecção de Gestos Para Controle de Drones</ExternalLink><span>SEMISH 2025 · pp. 215–226 · coautor</span></li>
        <li><ExternalLink href="https://doi.org/10.1109/CROS69211.2026.11565658">A Low-Cost Remotely Operated Underwater Vehicle for Educational Applications</ExternalLink><span>CROS 2026 · IEEE · coautor</span></li>
        <li><ExternalLink href="https://doi.org/10.5753/clihc.2026.21232">Sistema de Imitação via Visão Computacional aplicado a um Braço Robótico de baixo custo para fins educacionais</ExternalLink><span>CLIHC 2026 · coautor</span></li>
      </ul>
    </section>
    <section className="profile-section" aria-labelledby="awards-heading">
      <h2 id="awards-heading">Reconhecimentos e comunidade</h2>
      <ul className="recognition-list">
        <li>2º lugar na categoria Jovem Cientista / Inovação Tecnológica do XIV Prêmio João Ribeiro (FAPITEC, 2026).</li>
        <li>Melhor artigo em Ciências Exatas e da Terra na SNCT / IFS (2024).</li>
        <li>Projeto entre os cinco selecionados da Vitrine EPT na SNEPT (MEC, 2024).</li>
        <li>Participação no GDG Aracaju e em ações de ensino de robótica em escolas.</li>
      </ul>
    </section>
  </div>
);

export default ProfileOverview;
